export const QA_NAME_CONNECT_SERVICE_REQUESTS = 'connectServiceRequests'
